import { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { CarCardHeader } from "./CarCardHeader";
import { CarCardStatusSelector } from "./CarCardStatusSelector";
import { CarCardTabs, TabType } from "./CarCardTabs";
import { CarCardTabContent } from "./CarCardTabContent";
import { VehicleCardDetails } from "@/types/vehicleCard";
import { VehicleCardStatus } from "@/types/enums";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels, commonMiscLabels } from "@/i18n";

interface CarCardContentProps {
  vehicleCard: VehicleCardDetails | undefined;
}

export const CarCardContent = ({ vehicleCard }: CarCardContentProps) => {
  const [activeTab, setActiveTab] = useState<TabType>("info");
  const [status, setStatus] = useState<string>(
    vehicleCard?.status || VehicleCardStatus.INCOMPLETE
  );

  // Safety check for undefined vehicleCard
  if (!vehicleCard) {
    return (
      <Card className="shadow-lg w-full max-w-4xl">
        <CardContent className="p-6">
          <div className="text-center text-muted-foreground">
            {vehicleCardUILabels(getLanguage()).vehicleCardDataNotLoaded}
          </div>
        </CardContent>
      </Card>
    );
  }

  const regNumber = vehicleCard.vehicleDetails?.regNumber;

  return (
    <Card className="shadow-lg w-full max-w-4xl">
      <CardHeader className="p-3 md:p-6 space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <CarCardHeader
            regNumber={regNumber}
            id={vehicleCard.vehicleCardId}
            make={
              vehicleCard.vehicleDetails?.make ||
              commonMiscLabels(getLanguage()).unknown
            }
            model={
              vehicleCard.vehicleDetails?.model ||
              commonMiscLabels(getLanguage()).unknown
            }
            status={status}
          />
          <div className="w-full sm:w-auto">
            <CarCardStatusSelector
              initialStatus={vehicleCard.status}
              onStatusChange={setStatus}
              vehicleCardId={vehicleCard.id}
            />
          </div>
        </div>

        <CarCardTabs activeTab={activeTab} onTabChange={setActiveTab} />
      </CardHeader>

      <CardContent className="px-6">
        <CarCardTabContent activeTab={activeTab} vehicleCard={vehicleCard} />
      </CardContent>
    </Card>
  );
};
